import styled from 'styled-components';
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`

  .registration-table-page {
    flex: 1;
    min-height: 1000px;

    .registration-table-area {
      padding: 10px 0;
      background: #f8f8f8;
      min-height: 1000px;

      .registration-user-details {
        max-width: 1800px;
        margin: auto;
        padding: 25px 30px;
        border-radius: 5px;

        .image-container-apssdc {
          display: flex;
          justify-content: center;
          gap: 60px;
          margin-bottom: 30px;
        }
        @media (max-width: 600px) {
          .image-container-apssdc {
              flex-direction: column;
              align-items: center;
          }
        }
    
        .registration-header {
          h4 {
              color : ${colors.black2};
              text-transform: uppercase;
              font-weight: 600;
              font-size: 20px;
              padding-bottom: 10px;
              margin-bottom: 20px;
              position: relative;
              &:before {
                  position: absolute;
                  content: "";
                  background: ${colors.green};
                  width: 100px;
                  height: 2px;
                  bottom: 0;
                  left: 50%;
                  margin-left: -50px;
              }
    
              @media(max-width: 575px) {
                  font-size : 20px;
              }
          }
        }
      }

      .college-registration-area {
        max-width: 1800px;
    
        margin: auto;
        padding: 25px 30px;
        border-radius: 5px;
    
        .college-template-area {
          .scrollable-container {
            border: 2px solid ${colors.border4};
            border-radius: 10px;
            padding-top: 15px;
            padding-right: 15px;
            padding-bottom: 0;
            padding-left: 15px;
            margin-top: 5px;
            overflow-x: auto; /* Enable horizontal scrolling */
            white-space: nowrap; /* Prevent line breaks within the table */
          }

          .dropdown-area {
            margin-top: 25px;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            white-space: nowrap; /* Prevent line breaks within the table */
          }
          
          th, td {
            padding-left: 10px;
            padding-right: 10px;
            border-bottom: 1px solid ${colors.border3};
          }
          
          th {
            text-align: left;
            font-weight: bold;
          }
          
          input[type='email'],
          input[type='text'] {
            width           : 100%;
            height          : 48px;
            background-color: #ffffff;
            font-size       : 14px;
            padding         : 15px 20px;
            color           : ${colors.black1};
            border          : 1px solid ${colors.border3};
            border-radius : 5px;
          }
          
          button {
            padding: 5px 10px;
            background-color: ${colors.primary};
            color: ${colors.white};
            border: none;
            border-radius: 5px;
            cursor: pointer;
          }
          
    
          .btn {
            width: 300px !important;
            display: inline-block;
            padding: 10px 20px;
            background-color: ${colors.primary};
            color: #fff;
            border: none;
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s;
      
            &.active {
              background-color: ${colors.secondary};
            }
      
            &:hover {
              background-color: ${colors.secondary};
            }
          }
        }
      }

      .bulk-registration-area {
        max-width: 1800px;
        margin: auto;
        padding: 25px 30px;
        border-radius: 5px;
    
        .bulk-registration-header {
          h4 {
            color : ${colors.black2};
              text-transform: uppercase;
              font-weight: 600;
              font-size: 20px;
              padding-bottom: 10px;
              margin-bottom: 20px;
              position: relative;
              &:before {
                  position: absolute;
                  content: "";
                  background: ${colors.green};
                  width: 50px;
                  height: 2px;
                  bottom: 0;
                  left: 50%;
                  margin-left: -25px;
              }
    
              @media(max-width: 575px) {
                  font-size : 20px;
              }

             
          }
        }

        .refresh-button {
          margin-right: 10px;
          // color: pink;
          /* Add any additional styling for the refresh button */
        }

        .btn {
          width: 300px !important;
          display: inline-block;
          padding: 10px 20px;
          background-color: ${colors.primary};
          color: #fff;
          border: none;
          border-radius: 5px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s;
    
          &.active {
            background-color: ${colors.secondary};
          }
    
          &:hover {
            background-color: ${colors.secondary};
          }
        }
    
        .bulk-template-area {
          .scrollable-container {
            border: 2px solid ${colors.border4};
            border-radius: 10px;
            padding-top: 15px;
            padding-right: 15px;
            padding-bottom: 0;
            padding-left: 15px;
            margin-top: 5px;
            overflow-x: auto; /* Enable horizontal scrolling */
            white-space: nowrap; /* Prevent line breaks within the table */
          }

          .dropdown-area {
            margin-top: 25px;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            white-space: nowrap; /* Prevent line breaks within the table */
          }
          
          th, td {
            padding-left: 10px;
            padding-right: 10px;
            border-bottom: 1px solid ${colors.border3};
          }
          
          th {
            text-align: left;
            font-weight: bold;
          }
          
          input[type='email'],
          input[type='text'] {
            width           : 100%;
            height          : 48px;
            background-color: #ffffff;
            font-size       : 14px;
            padding         : 15px 20px;
            color           : ${colors.black1};
            border          : 1px solid ${colors.border3};
            border-radius : 5px;
          }
          
          button {
            padding: 5px 10px;
            background-color: ${colors.primary};
            color: ${colors.white};
            border: none;
            border-radius: 5px;
            cursor: pointer;
          }
          
    
          .btn {
            width: 300px !important;
            display: inline-block;
            padding: 10px 20px;
            background-color: ${colors.primary};
            color: #fff;
            border: none;
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s;
      
            &.active {
              background-color: ${colors.secondary};
            }
      
            &:hover {
              background-color: ${colors.secondary};
            }
          }
        }
    
        .manual-add-area {
          /* Add any styling for the manual add area */

          .scrollable-container {
            border: 2px solid ${colors.border4};
            border-radius: 10px;
            padding-top: 15px;
            padding-right: 15px;
            padding-bottom: 0;
            padding-left: 15px;
            margin-top: 5px;
            overflow-x: auto; /* Enable horizontal scrolling */
            white-space: nowrap; /* Prevent line breaks within the table */
          }

          .dropdown-area {
            margin-top: 25px;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            white-space: nowrap; /* Prevent line breaks within the table */
          }
          
          th, td {
            padding-left: 10px;
            padding-right: 10px;
            border-bottom: 1px solid ${colors.border3};
          }
          
          th {
            text-align: left;
            font-weight: bold;
            font-size: 15px;
          }
          
          input[type='email'],
          input[type='text'] {
            width           : 100%;
            height          : 48px;
            background-color: #ffffff;
            font-size       : 14px;
            padding         : 15px 20px;
            color           : ${colors.black1};
            border          : 1px solid ${colors.border3};
            border-radius : 5px;
          }
          
          button {
            padding: 5px 10px;
            background-color: ${colors.primary};
            color: ${colors.white};
            border: none;
            border-radius: 5px;
            cursor: pointer;
          }
          
    
          .btn {
            width: 300px !important;
            display: inline-block;
            padding: 10px 20px;
            background-color: ${colors.primary};
            color: #fff;
            border: none;
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s;
      
            &.active {
              background-color: ${colors.secondary};
            }
      
            &:hover {
              background-color: ${colors.secondary};
            }
          }
        }
    
      }
    }
  }
  
  .error-message {
    color: #dc3545;
    margin-top: 5px;
    font-size: 12px;
  }

  .form-field {
    padding: 0;
    height: auto;
    background : transparent;
    border: none;
    margin-bottom: 28px;
    position: relative;

    label {
      font-size : 15px;
      color : ${colors.text1};
      font-weight : 500;

      @media(max-width: 575px) {
          font-size : 14px;
      }
    }

    input {
      width           : 100%;
      height          : 48px;
      background-color: #ffffff;
      font-size       : 14px;
      padding         : 15px 20px;
      color           : ${colors.black1};
      border          : 1px solid ${colors.border3};
      border-radius : 5px;

      &::placeholder {
        font-size : 14px;
        font-style: italic;
        color: ${colors.text3};

        @media(max-width: 575px) {
          font-size : 13px;
        }
      }

      &:disabled {
        background-color: #e1e2e3;
        color: #6c757d;
        border-color: #ced4da;
      }

      &:focus {
        border-color : ${colors.green};
      }

      @media(max-width: 575px) {
        height : 40px;
      }
    }
  }

  .verification-icon i {
    font-size: 24px;
    margin-left: 15px;
  }

  .verification-icon .icon-check i {
    color: green;
  }

  .verification-icon .icon-cross i {
    color: red;
  }

  .remove-row-icon {
    font-size: 24px;
    margin-bottom: 20px;
    color: red;
  }

  .add-row-icon {
    font-size: 33px;
    color: ${colors.border4};
  }

  .file-upload {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
  }
  
  .file-note {
    margin-top: 10px;
    // align-self: flex-start; /* Add this line to align to the left side */
  }
  
  .template-download-button {
    display: inline-block;
    background-color: #f0ad4e;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    text-decoration: none;
    margin-right: 10px;
  }
  
  .template-download-button a {
    color: white;
    text-decoration: none;
  }
  
  .template-download-button:hover {
    background-color: #e69533;
  }
  
  .template-download-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(240, 173, 78, 0.5);
  }
  
  .file-input {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .file-input input {
    margin-left: 10px;
  }
  
  
  .price-input {
    height: 50px !important;
  }

  .price-display {
    color: #06488f; 
    font-weight: 700;
    margin-top: 5px;
  }

  .price-display h3 {
    font-size: 24px; 
    font-weight: bold; 
  }

  .price-display label {
    
    font-size: 18px; 
    font-weight: normal;
  }

  .css-b62m3t-container{
    height: 48px !important;

      .css-13cymwt-control{
        height: 48px ;

        .css-1fdsijx-ValueContainer{
          height: 48px !important;

          .css-qbdosj-Input{
            height: 48px !important;
          }
        }

        .css-3w2yfm-ValueContainer{
          height: 48px ;

          .css-1p3m7a8-multiValue{
            position:relative;
            top: -5px;
          }
          .css-qbdosj-Input{
            height: 48px !important;
          }
        }

        .css-1hb7zxy-IndicatorsContainer{
          height: 48px !important;
        }

        .css-1fdsijx-ValueContainer{
          height: 48px !important;

          . css-1jqq78o-placeholder{
            postition: relative !important;
            top: 50px !important;
          }

        }

      }

  }

  }
`